import { render, staticRenderFns } from "./ContentClassical.vue?vue&type=template&id=3aa257e1&scoped=true"
import script from "./ContentClassical.vue?vue&type=script&lang=js"
export * from "./ContentClassical.vue?vue&type=script&lang=js"
import style0 from "./ContentClassical.vue?vue&type=style&index=0&id=3aa257e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa257e1",
  null
  
)

export default component.exports